import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { jwtDecode } from 'jwt-decode';

const useProtecaoDeRota = () => {
  const navegar = useNavigate();
  const [verificando, setVerificando] = useState(true);

  useEffect(() => {
    function validarToken() {
      const token = localStorage.getItem('token');
      
      try {
        if (!token) throw new Error('Token não encontrado');

        // Decodifica o token
        const decodedToken = jwtDecode(token);
        
        // Verifica se o token está expirado
        const now = Math.floor(Date.now() / 1000); // Tempo atual em segundos
        if (decodedToken.exp < now) throw new Error('Token expirado');

        // Se o token é válido e não está expirado
        setVerificando(false);
      } catch (erro) {
        message.error('Sessão expirada. Faça login novamente.');

        navegar('/login');
      }
    }

    // Validação inicial
    validarToken();

    // Configura o intervalo para validar a cada minuto (60000 ms)
    const intervalId = setInterval(() => {
      validarToken();
    }, 60000);

    // Cleanup: remove o intervalo quando o componente for desmontado
    return () => clearInterval(intervalId);
  }, [navegar]); // Dependência apenas do navegar

  return verificando;
};

export default useProtecaoDeRota;